import React from 'react';

const About = ({ ...props }) => (
  <div>About Page</div>
);

export default About;
